import Header from "components/Headers/Header";
import { ErrorMessage, Formik } from "formik";
import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import { updateStatus } from "utils/endpoint";
import * as yup from "yup";
import clsx from "clsx";
import UseFullPageLoader from "utils/UseFullPageLoader";
import useSearchParams from "utils/useSearchParams";
import ProtectedRoute from "components/ProtectedRoute";

const validationSchema = yup.object({
  name: yup.string().required("Name is required"),
});
function UpdateStatus() {
  const { state } = useLocation();
  const [statusQueryParams, setStatusQueryParams] = useSearchParams();
  const currentPage = statusQueryParams.currentPage;
  const fromDate = statusQueryParams.fromDate;
  const toDate = statusQueryParams.toDate;
  const is_active = statusQueryParams.is_active;
  const navigate = useNavigate();
  const [status] = useState(state.row);
  const [loader, showLoader, hideLoader] = UseFullPageLoader();
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const { id } = params;

  const handleSearchParams = () => {
    const baseUrl = `/admin/status/status-list`;
    const url = new URL(baseUrl, window.location.origin);
    const params = new URLSearchParams();

    if (id) params.set("id", id);
    if (currentPage) params.set("page", currentPage);
    if (fromDate) params.set("from_date", fromDate);
    if (toDate) params.set("to_date", toDate);
    if (is_active || is_active === "false") {
      params.set(
        "is_active",
        is_active === "true" ? "true" : is_active === "none" ? "none" : "false"
      );
    }

    url.search = params.toString();
    return url.toString().replace(window.location.origin, "");
  };



  return (
    <Formik
      enableReinitialize
      initialValues={{
        name: status?.name,
        description: status?.description,
        is_active: status?.is_active ?? "",
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        setLoading(true);
        showLoader()
        const updateData = {
          name: values.name,
          description: values.description,
          is_active: values.is_active,
        };
        const result = await updateStatus(id, updateData);
        if (result?.isSuccess) {
          toast.success(`${result.message}`);
          setLoading(false);
          hideLoader()
          resetForm();
          const url = handleSearchParams()
          navigate(url);
        } else {
          setSubmitting(false);
          setLoading(false);
          hideLoader()
          return toast.error(
            result.message || `Something went wrong, please try again letter!`
          );
        }
      }}>
      {({
        handleChange,
        handleSubmit,
        values,
        errors,
        touched,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} autoComplete="off">
          <>
            <Header />

            <Container className="mt--7" fluid>
              <Row>
                <div className="col">
                  <Card className="shadow">
                    <CardHeader className="border-0">
                      <Row>
                        <Col lg="6">
                          <h1 className="mb-0">Update Status</h1>
                        </Col>
                        <Col lg="6" className="add_btn text-right">
                          <Button
                            color="primary"
                            className=""
                            onClick={() => {
                              const url = handleSearchParams();
                              navigate(url);
                            }}>
                            <span className="me-2">Back</span>
                          </Button>
                        </Col>
                      </Row>

                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label required">
                              Name
                            </label>
                            <Input
                              className={clsx("form-control", {
                                "is-invalid":
                                  Boolean(errors.name) && touched.name,
                              })}
                              id="name"
                              name="name"
                              placeholder="Name"
                              type="text"
                              value={values.name}
                              onChange={handleChange}
                            />
                            <div className="text-danger text-align-top-center mt-1">
                              <ErrorMessage name="name" />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label className="form-control-label ">
                              Description
                            </label>
                            <Input
                              className="form-control"
                              id="description"
                              name="description"
                              placeholder="Description"
                              type="text"
                              value={values.description}
                              onChange={handleChange}
                            />
                          </FormGroup>
                        </Col>

                      </Row>

                      <Row>
                        <Col lg="3">
                          <Button
                            type="submit"
                            className="my-3 w-100"
                            color="primary">
                            {loading && (
                              <span
                                className="indicator-progress"
                                style={{ display: "block" }}>
                                Please Wait..
                                <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                              </span>
                            )}
                            {!loading && (
                              <span className="indicator-label">
                                Update Status
                              </span>
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
              </Row>
            </Container>
            {loader}
          </>
        </form>
      )}
    </Formik>
  );
}

const ProtectedUpdateStatus = () => (
  <ProtectedRoute requiredPermissions="update-status">
    <UpdateStatus />
  </ProtectedRoute>
);

export default ProtectedUpdateStatus;
